module.exports = __webpack_public_path__ + "static/img/b3.dc904ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b3.jpg
// module id = G/w5
// module chunks = 1